import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-pro-wa-polar-area-chart',
	templateUrl:'./WaPolarAreaChartProPage.html',
	styles: [],
	styleUrls:['./WaPolarAreaChartProPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaPolarAreaChartProPage
{
	mdContent_420 = `\`\`\`java
import com.jwebmp.webawesomepro.components.chart.WaPolarAreaChart;
\`\`\``;
	mdContent_421 = `\`\`\`java
new WaPolarAreaChart<>()
\`\`\``;
}
